export default "__VITE_ASSET__CoF0sQ8A__"